import React from "react";
import { Typography, Grid, Box } from "@mui/material";
import { ErpSaveUpdateButton } from "app/shared/ReuseComponents/ButtonComponent";
import { AiFillEye } from "react-icons/ai";
import { getDocumentDetails } from "app/utils/documentUtils";

const DocumentHeader = ({ workflowName, requests, onViewDocument }) => {
  console.log("details", requests)
  const details = getDocumentDetails(workflowName, requests);


  return (
    <>
      <Typography variant="h3" fontWeight="bold">
        Document Approvals
      </Typography>

      <Typography variant="h4">
        Approvers shall use this form to approve or reject documents received from users
      </Typography>

      <Grid
        container
        spacing={2}
        alignItems="center"
        sx={{ mt: 2 }}
      >
        {/* LEFT CONTENT */}
        <Grid item xs={12} md={8}>
          <Grid container spacing={1}>
            {/* Labels */}
            <Grid item xs={5} sm={4} md={3}>
              <Typography  variant="h5" fontWeight={600}>Document Type</Typography>
              {details?.additionalFields?.map((field, index) => (
                <Typography variant="h5" key={index} fontWeight={600}>
                  {field.label}
                </Typography>
              ))}
            </Grid>

            {/* Colon */}
            <Grid item xs={1}>
              <Typography variant="h5" fontWeight={600}>:</Typography>
              {details?.additionalFields?.map((_, index) => (
                <Typography variant="h5" key={index} fontWeight={600}>
                  :
                </Typography>
              ))}
            </Grid>

            {/* Values */}
            <Grid item xs={6} sm={7} md={8}>
              <Typography variant="h5">{workflowName}</Typography>
              {details?.additionalFields?.map((field, index) => (
                <Typography key={index} variant="h5">{field.value}</Typography>
              ))}
            </Grid>
          </Grid>
        </Grid>

        {/* RIGHT BUTTON */}
        <Grid
          item
          xs={12}
          md={4}
          display="flex"
          justifyContent={{ xs: "center", md: "flex-end" }}
        >
          <ErpSaveUpdateButton
            name="View Document"
            onClick={onViewDocument}
            icon={<AiFillEye size={18} />}
            width="200px !important"
          />
        </Grid>
      </Grid>
    </>
  );
};

export default DocumentHeader;
